// Minimal CSV exporter — no external deps.
// Triggers a browser download for the given rows/columns.
//
// columns: [{ key: 'agent_name', label: 'Agente' }, ...]
// rows:    [{ agent_name: 'Gloria', ... }, ...]
// filename: 'reporte-ventas-2026-05.csv'

function escapeCell(value) {
  if (value === null || value === undefined) return '';
  const s = typeof value === 'string' ? value : String(value);
  // RFC 4180: si contiene coma, comilla o salto de línea, envolver en comillas
  // y escapar las comillas duplicándolas.
  if (/[",\n\r]/.test(s)) {
    return `"${s.replace(/"/g, '""')}"`;
  }
  return s;
}

export function exportCSV({ columns, rows, filename = 'export.csv' }) {
  const header = columns.map((c) => escapeCell(c.label || c.key)).join(',');
  const body = rows
    .map((row) => columns.map((c) => escapeCell(row[c.key])).join(','))
    .join('\n');
  // BOM para que Excel abra UTF-8 correctamente (caracteres como ñ/acentos).
  const csv = '﻿' + header + '\n' + body;

  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}
